import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { AlertsTableFilterSchema } from "./_list/-zod-schema";

export const Route = createFileRoute("/_staff/starlinks/_layout/alerts/")({
  validateSearch: zodValidator(AlertsTableFilterSchema),
});
